﻿/// <reference path="./libs/phaser.d.ts" />

export namespace BattleCity
{
    export class Preloader extends Phaser.State
    {
        preloadBar: Phaser.Sprite;

        preload()
        {
            this.preloadBar = this.game.add.sprite(200, 250, "preloadBar");
            this.load.setPreloadSprite(this.preloadBar);

            this.load.image("titlepage", "./assets/BattleCityTitle_512x512.png");

            this.load.atlasJSONHash("battleCityScene", "./assets/battle_city_tiles_32px.png", "./assets/battle_city_tiles_32px.json");
        }

        create()
        {
            this.game.state.start('MainMenu', true, false);
        }
    }
}
